export const NetworkGrant = ['admin', 'technician', 'viewer']
